<script setup lang="ts">
import {ref} from "vue";
const emit = defineEmits(['selectAddress', 'closeAddressModal']);
const props = defineProps(['address1', 'address2']);

const selectedAddress = ref(1);
const handleCloseModal = () => {
  emit('closeAddressModal')
}

const handleSelectAddress = () => {
  emit('selectAddress', {
    address: selectedAddress.value === 1 ? props.address2 : props.address1,
    value: selectedAddress.value
  });
}
</script>

<template>
  <div class="address-popup is-visible">
    <div class="address-popup__dialog">
      <div class="address-popup__overlay"></div>
      <div class="address-popup__content">
        <h2 class="address-popup__heading">Verify your shipping address</h2>
        <div class="address-popup__body">
          <p class="address-popup__top-desc">Select which address you want to use. <br><strong>Please note:</strong> Shipping with an unverified address may cause delays in shipping.</p>
          <div class="address-popup__variatns">
            <label class="address-popup__variant" id="address-popup-customer">
              <input type="radio" name="address-variant" aria-label="Entered Address" class="address-popup__variant-input" value="0" v-model="selectedAddress">
              <p>
                <strong>Your Entered Address</strong>
                <span class="address-popup__variant-name">{{ address1.first_name }} {{ address1.last_name }}</span>
                <span class="address-popup__variant-address">{{ address1.address1 + ', ' + address1.address2 || '' }}<br> {{ address1.city + ', ' + address1.province_code + ' ' + address1.zip }}</span>
              </p>
            </label>
            <p class="address-popup__divider">OR</p>
            <label class="address-popup__variant" id="address-popup-fedex">
              <input type="radio" name="address-variant" aria-label="Suggested Address" class="address-popup__variant-input" value="1" v-model="selectedAddress">
              <p>
                <strong>Suggested Address</strong>
                <span class="address-popup__variant-name">{{ address2.first_name }} {{ address2.last_name }}</span>
                <span class="address-popup__variant-address">{{ address2.address1 + ', ' + address2.address2 }}<br> {{ address2.city + ', ' + address2.province_code + ' ' + address2.zip }}</span>
              </p>
            </label>
          </div>
          <button class="address-popup__btn" type="button" @click.prevent.stop="handleSelectAddress">Continue with this address</button>
          <p class="address-popup__edit-text">Are neither of these addresses correct? <a href="#" @click.stop.prevent="handleCloseModal">Edit Address</a></p>
        </div>
      </div>
    </div>
  </div>
</template>